var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_1212_16153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 58.6665C34.9337 58.6665 37.3337 56.2665 37.3337 53.3332H26.667C26.667 56.2665 29.067 58.6665 32.0003 58.6665ZM48.0003 42.6665V29.3332C48.0003 21.1465 43.6537 14.2932 36.0003 12.4798V10.6665C36.0003 8.45317 34.2137 6.6665 32.0003 6.6665C29.787 6.6665 28.0003 8.45317 28.0003 10.6665V12.4798C20.3737 14.2932 16.0003 21.1198 16.0003 29.3332V42.6665L10.667 47.9998V50.6665H53.3337V47.9998L48.0003 42.6665ZM42.667 45.3332H21.3337V29.3332C21.3337 22.7198 25.3603 17.3332 32.0003 17.3332C38.6403 17.3332 42.667 22.7198 42.667 29.3332V45.3332Z",
    fill: "#A7B1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1212_16153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no_notifications.46937bfe1753ec224e7a4002f9486ee8.svg";
export { ForwardRef as ReactComponent };